import { createSlice } from '@reduxjs/toolkit';
import { AssistantStatus } from '../constants/assistant.constants';
import { getConversation } from './thunks/conversationThunks';
const initialState = {
    activeConversationId: null,
    status: AssistantStatus.IDLE,
    conversationBlockingError: null,
    messageStreamingError: null,
    conversations: {},
    isConnected: false,
    activeToolCall: null,
    processingNoticeConversationIds: {},
    modelAutoSwitch: null,
};
const assistantSlice = createSlice({
    name: 'assistant',
    initialState,
    reducers: {
        setAssistantStatus: (state, action) => {
            state.status = action.payload;
        },
        setAssistantActiveToolCall: (state, action) => {
            state.activeToolCall = action.payload;
        },
        setConversationBlockingError: (state, action) => {
            state.conversationBlockingError = action.payload;
            state.status = AssistantStatus.ERROR;
        },
        clearConversationBlockingError: (state) => {
            state.conversationBlockingError = null;
            if (state.status === AssistantStatus.ERROR) {
                state.status = AssistantStatus.IDLE;
            }
        },
        setMessageStreamingError: (state, action) => {
            state.messageStreamingError = action.payload;
        },
        clearMessageStreamingError: (state) => {
            state.messageStreamingError = null;
        },
        setSSEConnection: (state, action) => {
            state.isConnected = action.payload;
        },
        markConversationProcessingNotice: (state, action) => {
            state.processingNoticeConversationIds[action.payload] = true;
        },
        clearConversationProcessingNotice: (state, action) => {
            delete state.processingNoticeConversationIds[action.payload];
        },
        setModelAutoSwitch: (state, action) => {
            state.modelAutoSwitch = action.payload;
        },
        clearModelAutoSwitch: (state) => {
            state.modelAutoSwitch = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getConversation.pending, (state) => {
            state.status = AssistantStatus.PROCESSING;
            state.conversationBlockingError = null;
        })
            .addCase(getConversation.fulfilled, (state) => {
            state.status = AssistantStatus.IDLE;
            state.conversationBlockingError = null;
        })
            .addCase(getConversation.rejected, (state, action) => {
            state.status = AssistantStatus.ERROR;
            const errorMessage = action.error.message;
            if (errorMessage === 'Rejected' ||
                errorMessage === 'Network Error' ||
                (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.includes('fetch'))) {
                state.conversationBlockingError =
                    'Unable to connect to server. Please check your connection and try again.';
            }
            else {
                state.conversationBlockingError =
                    errorMessage || 'Failed to load conversation';
            }
        });
    },
});
export const { setAssistantStatus, setAssistantActiveToolCall, setConversationBlockingError, clearConversationBlockingError, setMessageStreamingError, clearMessageStreamingError, setSSEConnection, markConversationProcessingNotice, clearConversationProcessingNotice, setModelAutoSwitch, clearModelAutoSwitch, } = assistantSlice.actions;
export const assistantReducer = assistantSlice.reducer;
export { assistantSlice };
